import folder from "./folder.js";

export default function (element, data) {
    const folderDiv = document.createElement('div');
    folderDiv.className = 'folder project-image-folder';

    const folderWrapDiv = document.createElement('div');
    folderWrapDiv.className = 'folder-wrap';

    const folderContentDiv = document.createElement('div');
    folderContentDiv.className = 'folder-content';

    const openButton = document.createElement('button');
    openButton.type = 'button';
    openButton.className = 'folder-open';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'folder-close';

    const parent = element.parentNode;

    folderWrapDiv.appendChild(folderContentDiv);
    folderDiv.appendChild(folderWrapDiv);
    folderDiv.appendChild(openButton);
    folderDiv.appendChild(closeButton);

    parent.replaceChild(folderDiv, element);

    folderContentDiv.appendChild(element);

    folder(folderDiv, {
        collapsedHeight: 690,
    });
}
